import { action } from 'satcheljs';

export default action('SWEEP_DIALOG_ON_MOVE_TO_FOLDER_CLICK', (folderId: string) => ({
    folderId,
}));
